export default __webpack_public_path__ + "static/media/fire-outlined.f81ebb9e.svg";